const menuSticky = () => {
	const header = document.querySelector('.fixed-header');
	const navBar = document.querySelector('.nav-sticky');

	if (navBar) {

		header.style.height = navBar.offsetHeight + 'px';
		// apply initial height
		let navPosition = navBar.offsetTop;

		if (window.scrollY > navPosition) {
			header.classList.add('sticky');
		} else {
			header.classList.remove('sticky');
		}
	}

}

export default menuSticky;
